<template>
  <q-page-container>
    <q-page class="">
      <section class="section-cards-types-services">
        <div class="flex row justify-around q-pa-md">
          <q-card class="card-type-service q-mt-lg col-12">
            <q-card-section>
              <div class="text-center" v-if="loading">
                <q-spinner-hourglass color="red-6" size="6em" />
                <q-tooltip :offset="[0, 8]">QSpinnerHourglass</q-tooltip>
              </div>

              <div class="text-center">
                <h6>Informações da OS</h6>
              </div>
              <div class="q-mt-md q-pl-lg">
                <label><b>Protocolo:</b> {{ data.infomation_os.protocolo }}</label>
                <br />
                <label><b>Nº do contrato:</b>
                  {{ data.infomation_os.numero_contrato }}</label>
                <br />
                <label><b>Tipo OS:</b> {{ data.infomation_os.tipoos_refazerdesob }}</label>
                <br />
                <label><b>Cód. baixa:</b>
                  {{ data.infomation_os.descricao }}</label>
                <br />
                <label><b>Cidade:</b>
                  {{ data.infomation_os.cidade }}</label>
                <br />
                <label><b>Primeira data:</b>
                  {{ data.infomation_os.data_primaria }}</label>
                <br />
                <label><b>Hora inicio primeira data:</b>
                  {{ data.infomation_os.hora_inicial_primaria }}h</label>
                <br />
                <label><b>Hora fim primeira data:</b>
                  {{ data.infomation_os.hora_final_primaria }}h</label>
                <br />
                <label><b>Segunda data:</b>
                  {{ data.infomation_os.data_secundaria }}</label>
                <br />
                <label><b>Hora inicio Segunda data:</b>
                  {{ data.infomation_os.hora_inicial_secundaria }}h</label>
                <br />
                <label><b>Motivo:</b> {{ data.infomation_os.motivo }}</label>
                <br />
                <label><b>Observação:</b>
                  {{ data.infomation_os.observacao }}</label>
                <br />
                <label><b>Nome do técnico:</b>
                  {{ data.infomation_os.nome_tecnico }}</label>
                <br />
                <label><b>Telefone do técnico:</b>
                  {{ data.infomation_os.telefone }}</label>
                <br />
              </div>
              <div v-if="screenViewDetailsOs">
                <div class="flex column items-center">
                  <div class="q-mt-lg">
                    <q-btn color="secondary" label="Aprovar" @click="UpdateAttendanceLiberationLeader(true)" />
                  </div>
                  <div class="q-mt-lg">
                    <q-btn color="white" text-color="black" label="Reprovar"
                      @click="UpdateAttendanceLiberationLeader(false)" />
                  </div>
                </div>
              </div>
              <div class="text-uppercase text-center" v-if="screenViewResolveLeader">
                <h6>{{ messagemReturnForId }}</h6>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
import ConfirmationSMSLeader from "@/services/ConfirmationSMSLeaderServices";
import { onMounted, reactive, ref } from "vue";

export default {
  name: "ConfirmationSMSLeader",
  setup() {
    let confirmationSMSLeader = new ConfirmationSMSLeader();

    let data = reactive({
      infomation_os: Object,
      id_attendance: String,
    });

    let loading = ref(true);
    let screenViewDetailsOs = ref(false);
    let screenViewResolveLeader = ref(false);
    let messagemReturnForId = ref("");

    function _GetURLParameter() {
      var sPageURL = window.location.search.substring(1);

      var sURLVariables = sPageURL.split("&");
      for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] === "access_token") {
          localStorage.setItem("access_token", sParameterName[1]);
        }
        if (sParameterName[0] === "id_attendance") {
          data.id_attendance = sParameterName[1];
        }
      }
    }

    function _GetInformationOs() {
      loading.value = true;
      confirmationSMSLeader
        .GetInformationOs(data.id_attendance)
        .then((response) => {
          data.infomation_os = response;
          loading.value = false;
          if (data.infomation_os.id_status != 12 && data.infomation_os.id_status != 53) {
            screenViewResolveLeader.value = true;
            screenViewDetailsOs.value = false;
            _getMessageReturn(data.infomation_os.liberacao_lider)
          } else {
            screenViewResolveLeader.value = false;
            screenViewDetailsOs.value = true;
          }

        });
    }

    function _getMessageReturn(liberacao_lider) {
      if (liberacao_lider) {
        messagemReturnForId.value = "Solicitação aprovada para geração da OS."
      } else {
        messagemReturnForId.value = "Tempo de Aprovação Excedido."
      }

    }

    function UpdateAttendanceLiberationLeader(decision_leader) {
      loading.value = true;
      confirmationSMSLeader
        .UpdateAttendanceLiberationLeader(data.id_attendance, decision_leader)
        .then((response) => { });
      loading.value = false;
      screenViewResolveLeader.value = true;
      screenViewDetailsOs.value = false;
      setTimeout(() => {
        _GetInformationOs()
      }, 5000)

    }

    onMounted(() => {
      _GetURLParameter();
      _GetInformationOs();
    });

    return {
      data,
      loading,
      screenViewDetailsOs,
      screenViewResolveLeader,
      messagemReturnForId,
      UpdateAttendanceLiberationLeader,
    };
  },
};
</script>

<style lang="scss" scope>
</style>